// var isBrowser = typeof window !== 'undefined';
// const $ = isBrowser ? window.$ : {};
var React = require('react');
var createReactClass = require('create-react-class');
// var cookie = require('react-cookie');
var Helmet = require('react-helmet');
var PropTypes = require('prop-types');
var Header = require('../../components/header.jsx');
var Footer = require('../../components/footer.jsx');
var Callout = require('../../components/callout.jsx');
// var FacebookLikeModal = require('../../components/facebookLikeModal.jsx');
var ModalContainer = require('../../components/modals/modalContainer.jsx');
// var ActionMenu = require('../../components/actionMenu.jsx');
var SignUpBanner = require('../../components/signUpBanner.jsx');

var Main = createReactClass({
  componentDidMount: function () {
    // var $body = $('body');

/*    this.context.router.listen(function(){
      this.props.clearGenericError();
      this.props.clearGenericResponseError();
      this.props.hideModal();
      $body.removeClass('is-menu-open');
    }.bind(this)); */
  },

  componentWillReceiveProps: function(nextProps){
      // if(this.props.modal.type === 'MODAL_TYPE_INTERESTED_IN_CLINICAL_TRIALS' && nextProps.profile.data.contactForTrials && Object.keys(this.props.profile.data).length > 0 && !this.props.profile.data.contactForTrials){
      //     this.props.showModal('MODAL_TYPE_INTERESTED_SUCCESS');
      // }
      // if(nextProps.location.pathname !== '/dashboard/surveys/promis' && // for avoding conflict with promisModal
      //  Object.keys(nextProps.profile.data).length > 0 && !nextProps.profile.data.postalCode && Object.keys(this.props.profile.data).length === 0){
      //    this.props.showModal('MODAL_TYPE_COLLECT_ZIP_CODE_MODAL');
      // }
  },

  componentDidUpdate: function(){
      if(!this.props.auth.token && this.refs.signUpBanner){
          clearTimeout(this.positionSignUpBannerTimer);
          this.positionSignUpBannerTimer = setTimeout(function(){
              this.refs.signUpBanner.positionSignUpBanner();
          }.bind(this));
      }
  },

  handleLogout: function () {
    this.context.router.replace('/');
    this.props.logOut();
    typeof window.FB !== 'undefined' && window.FB.getLoginStatus(function(response) {
      if (response && response.status === 'connected') {
        window.FB.logout();
      }
    });
  },

  getPageID: function(){
    var pageID = 'home';
    var routeName = this.props.location.pathname;

    if (routeName !== '/') {
      // remove / trail, or /conditons/ will result pageID = page-condition
      routeName = routeName.replace(/\/$/, '');
      var path = routeName.split('/');
      if (path.length === 2) {
        pageID = path[path.length - 1];
      } else {
        switch (path[1]) {
          // we can't use :name as the pageID, especially when it is mainly used for "CSS" hook
          case 'conditions': // /conditions/:name
            pageID = 'condition';
            break;
          case 'password-reset': // /password-reset/:token
            pageID = 'password-reset'; // has side product here, /password-reset and /password-reset/:token will have same pageID
            break;
          case 'surveys':
            pageID = 'survey';
            break;
          case 'dashboard':
            pageID = path.slice(1).join('_');
            break;
          case 'blog':
            pageID = 'blog';
            break;
          default:
            // /education/symptoms/:name
            // /education/bodyparts/:name
            pageID = path[2];
        }
      }
    }

    pageID = 'page-' + pageID;

    return pageID;
  },

  render: function(){
    var pageID = this.getPageID();

    var bodyComponent = React.Children.map(this.props.children, function(child) {
      return React.cloneElement(child, {
        onLogout: this.handleLogout,
        showModal: this.props.showModal,
        hideModal: this.props.hideModal
      });
    }.bind(this));

    var isLogin = this.props.auth.user && this.props.auth.user.userId;
    // var shouldShowSignUpBanner = !cookie.load('noSignUpBanner') && !this.props.auth.isFetching && !isLogin;
    var shouldShowSignUpBanner = false;

    return (
      <div className={'outer-wrapper' + (isLogin ? ' is-logged-in' : '') + (shouldShowSignUpBanner ? ' show-signUpBanner' : '')} id={pageID}>
        <div >
          <Header
              isLogin={isLogin}
              auth={this.props.auth}
              profile={this.props.profile.data}
              clickTracking={this.props.recordEvent}
              onLogout={this.handleLogout}
              showModal={this.props.showModal}
              recordClinicalTrialsClick={this.props.recordClinicalTrialsClick} />
          <section className="page">
            <Helmet title='National health survey' titleTemplate = '%s'/>
            {this.props.generic_error &&
              <div className="row">
                <Callout type="alert" message={this.props.generic_error} handleClose={this.props.clearGenericError} />
              </div>
            }
            {this.props.generic_response_error &&
              <div className="row">
                <Callout type="alert" message={this.props.generic_response_error} handleClose={this.props.clearGenericResponseError} />
              </div>
            }
            {bodyComponent}
          </section>
          <ModalContainer />
          
          <iframe src="about:blank" id="heightChangeListener" tabIndex="-1" title=" "></iframe>{/* DONT REMOVE! assist for positioning SignUpBanner when content height changed */}
        </div>
        <Footer clickTracking={this.props.recordFooterClick} />
      
        {shouldShowSignUpBanner &&
            <SignUpBanner
                ref="signUpBanner"
                authFacebook={this.props.authFacebook}
                clickTracking={this.props.recordEvent} />
        }

{/*        {isLogin &&
            <ActionMenu />
        }

        {this.props.showFacebookLikeModal &&
          <FacebookLikeModal close={this.props.closeFacebookLikeModal} />
        }
*/}

      </div>
    )
  }
});

Main.contextTypes = {
  router: PropTypes.object.isRequired,
  store: PropTypes.object.isRequired
};

module.exports = Main;



// WEBPACK FOOTER //
// ./src/common/routes/main/components/main.jsx